export default __webpack_public_path__ + "static/media/messages.6b5e5d07.svg";